import { useSlicerVariables, useWidgetData } from "../Contexts/dashboardHooks";
import { WidgetInfoButton } from "../Info/WidgetInfoButton";
import { resolveTemplate } from "../Utils/resolveTemplate";

export function TitleWidget({ id }: { id: string }) {
  const data = useWidgetData(id);
  const slicerValues = useSlicerVariables();
  const rawTitle = data?.type === "title" ? data.spec.display.title : "Untitled";
  const { resolved } = resolveTemplate(rawTitle, slicerValues);

  // The title has no header row, so the info cluster floats like the player card's.
  return (
    <div className="title-widget" data-grid-id={id} style={{ position: "relative" }}>
      <span className="widget-floating-info">
        <WidgetInfoButton id={id} />
      </span>
      <span className="title-widget-text">{resolved}</span>
    </div>
  );
}
